import { defineRule, configure } from 'vee-validate'
import { email, min, required, confirmed, size } from '@vee-validate/rules'

configure({
    validateOnModelUpdate: false,

})

defineRule('required', required)
defineRule('email', email)
defineRule('min', min)
defineRule('confirmed', confirmed)
defineRule('size', size)

defineRule('slug', (value) =>
    /^[a-z0-9-]+$/.test(String(value ?? '')) ||
    'Only lowercase letters, digits and dashes')

defineRule('port', (value) =>
    (/^\d+$/.test(String(value ?? '')) && +value >= 1 && +value <= 65535) ||
    'Must be a port number between 1 and 65535')

defineRule('url_path', (value) =>
    /^\/\S*$/.test(String(value ?? '')) ||
    'Must start with /')

defineRule('ipv4', (value) =>
    /^((25[0-5]|2[0-4]\d|1?\d?\d)\.){3}(25[0-5]|2[0-4]\d|1?\d?\d)$/.test(String(value ?? '')) ||
    'Must be a valid IPv4 address')

defineRule('http_url', (value) =>
    /^https?:\/\/[^\s/$.?#].[^\s]*$/i.test(String(value ?? '')) ||
    'Must be a valid http(s) URL')
